import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

export default {
  carregaMensagemUsuario: async idUsuario => {
    return Vue.http.get(`/api/chat/${idUsuario}/mensagemusuario`)
      .then(response => response.data);
  },
  carregaCanais: async idUsuario => {
    return Vue.http.get(`/api/chat/${idUsuario}/canais`)
      .then(response => response.data);
  },
  carregaMensagens: async (idUsuarioOrigem, idChanel) => {
    if ((!idUsuarioOrigem) & (!idChanel))
      return

    return Vue.http.get(`/api/chat/mensagens`,
      {
        params: {
          idUsuarioOrigem: idUsuarioOrigem,
          idChanel: idChanel,
        }
      })
      .then(response => response.data);
  },
  enviarMensagem: async (mensagem) => {
    mensagem = await converterObjetoFormData(mensagem)

    return Vue.http.post(`/api/chat/enviarmensagem`, mensagem)
      .then(response => response.data);
  },
  carregarGrupos: async idUsuario => {
    return Vue.http.get(`/api/chat/${idUsuario}/grupos`)
      .then(response => response.data);
  },
  carregarUsuarios: async idUsuario => {
    return Vue.http.get(`/api/chat/${idUsuario}/usuarios`)
      .then(response => response.data);
  },
  adicionar: (grupo) => {
    grupo = converterObjetoFormData(grupo);

    return Vue.http.post('/api/chat/grupo', grupo).then(res => res.data.id);
  },
  alterar: (grupo) => {
    grupo = converterObjetoFormData(grupo);

    return Vue.http.put(`/api/chat/grupo`, grupo).then(res => res.data.id);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/chat/servico.js